import React, {useEffect, useState,memo} from 'react';
import {BrandAutoComplete, Head, Loading, MapReport, TicketConversation} from "../../components";
import Container from "@mui/material/Container";
import {Box, CircularProgress, Tooltip} from "@mui/material";
import moment from 'moment-jalaali'
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { UserAutocomplete} from './../../components'
import {useDispatch, useSelector} from "react-redux";
import {period} from "../../actions";
import {useLocation} from "react-router-dom";
import PeriodAutoComplete from "../../components/Period";
import ReactFC from "react-fusioncharts";
import Api from "../../utils/api";
import MarketerOperationSalesExport from "./excel/sales";
import MarketerOperationMapExport from "./excel/map";
import {useNavigate} from "react-router";
import queryString from 'query-string';

const MarketerOperation = ( props ) => {


    const location = useLocation();
    const history = useNavigate();

    const dispatch = useDispatch();
    const  AppState  = useSelector(state => state);

    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);

    const [mapReport, setMapReport] = useState([]);
    const [chart, setChart] = useState({});
    const chartConfigs = {
        type: 'mscombi2d',// The chart type
        width: '100%', // Width of the chart
        height: '400', // Height of the chart
        dataFormat: 'json', // Data type
        dataSource: {
            "chart": {
                "caption": "گزارش میزان فروش",
                // "subCaption": "گزارش 30 روز گذشته",
                "yAxisName": "مبلغ به تومان",
                "theme": "fusion",
                "formatNumberScale" : '0',
                "decimalSeparator": ".",
                "thousandSeparator": ",",
            },
            "categories": [
                {
                    "category": chart.label
                }
            ],
            "dataset": [
                {
                    "seriesName": "تعداد فاکتور",
                    "renderAs": "line",
                    "data": chart.count
                },
                {
                    "seriesName": "مبلغ فروش",
                    "renderAs": "line",
                    "data": chart.price
                }
            ]
        }
    };

    useEffect(() => {

        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);



    const handleChangeSearchInputWithAutoComplete = (name, value) => {
        _makeQueryStringParams(name, value)
    }


    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        month_id: query.month_id ? parseInt(query.month_id) : '',
        period_id: query.period_id ? parseInt(query.period_id) : '',
        marketer_id: query.marketer_id ? parseInt(query.marketer_id) : '',
    });


    const handleRequest = () => {

        if (params.marketer_id && !isNaN(params.marketer_id)) {
            setLoading(true);

            new Api().get('/marketers/'+params.marketer_id+'/sales-daily-report', params).then((response) => {
                if (typeof response != "undefined") {

                    setChartData(response.data);

                    let chart = {
                        label: [],
                        price: [],
                        count: []
                    };

                    response.data.map((r, key) => {
                        chart.label.push({'label' : moment(r.label, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jM/jDD')});
                        chart.price.push({'value' : r.total_pay});
                        chart.count.push({'value' : r.total_count});
                    });

                    setChart(chart);
                    setLoading(false);
                }
            })

            new Api().get('/marketers/'+params.marketer_id+'/mapReports', params).then((response) => {
                if (typeof response !== "undefined") {
                    setMapReport(response.data);
                    setLoading(false)
                }
            })
        }

    }

    useEffect(() => {

        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.month_id,
        params.period_id,
        params.marketer_id,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'month_id':
                    if (n_params.month_id !== query.month_id) {
                        n_params.month_id = parseInt(query.month_id);
                    }
                    break;
                case 'period_id':
                    if (n_params.period_id !== query.period_id) {
                        n_params.period_id = parseInt(query.period_id);
                    }
                    break;
                case 'marketer_id':
                    if (n_params.marketer_id !== query.marketer_id) {
                        n_params.marketer_id = parseInt(query.marketer_id);
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.period_id,
        query.month_id,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'month_id':
                n_params.month_id = value;
                break;
            case 'period_id':
                n_params.period_id = value;
                break;
            case 'marketer_id':
                n_params.marketer_id = value;
                break;

        }

        // create url
        let url = '?';
        url += `&month_id=${n_params.month_id}`;
        url += `&period_id=${n_params.period_id}`;
        url += `&marketer_id=${n_params.marketer_id}`;


        history.push(`/operation/${url}`);

    };

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'عملکرد بازاریاب به تفکیک دوره ها', 'description': 'عملکرد بازاریاب' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={true}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('marketer_id', value)}/>
                            </Grid>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                {params.marketer_id && chartData.length > 0 && <MarketerOperationSalesExport marketer={params.marketer_id} entities={chartData} />}
                {params.marketer_id && <MarketerOperationMapExport marketer={params.marketer_id} entities={mapReport} />}
            </div>
            <Box style={{ margin: '30px 0', minHeight: '400px', position: 'relative'}}>
                {loading ? <CircularProgress className='centeral' size={15} color="secondary" /> : <ReactFC {...chartConfigs}/>}
            </Box>
            {!loading && mapReport && <MapReport list={mapReport}/>}
        </Container>

    );
}


export default memo(MarketerOperation);
